module.exports = __webpack_public_path__ + "media/hero_mv.c5e3f03f.webm";